(() => {
  const stlDesktopSwiper = new Swiper(".js-stl-desktop-card-swiper", {
    loop: false,
    pagination: {
      el: ".js-stl-desktop-card-pagination",
    },
  });

  const radioButtons = document.querySelectorAll(".js-stl__radio-button__dekstop");

  Array.from(radioButtons).forEach(function (btn, i) {
    btn.addEventListener("change", () => {
      stlDesktopSwiper.slideTo(i, 200, false);
    });
  });

  // Update radio buttons when slides change (including manual drag/swipe)
  stlDesktopSwiper.on("slideChange", function () {
    const activeIndex = stlDesktopSwiper.realIndex;
    if (radioButtons[activeIndex]) {
      radioButtons[activeIndex].checked = true;
    }
  });

  // Also handle snapIndexChange for programmatic changes
  stlDesktopSwiper.on("snapIndexChange", function () {
    const activeIndex = stlDesktopSwiper.realIndex;
    if (radioButtons[activeIndex]) {
      radioButtons[activeIndex].checked = true;
    }
  });
})();
